<template>
  <div class="content-container">
    <search-comp @onSearch="onSearch" @onReset="onResetSearch">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Tên sự kiện' }}
                </div>
                <div class="">
                  <input type="text" placeholder="selectwithsearch" />
                </div>
              </div>
            </div>
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Người thao tác' }}
                </div>
                <div class="">
                  <input type="text" placeholder="selectwithsearch" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>

    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container" style="display: flex">
            <div class="das-form-title">
              <span class="main-title">
                {{ `Báo cáo doanh thu theo sự kiện` }}
              </span>
            </div>

            <DownloadBtn @openNoteDialog="dialogNoteVisible = true" />
          </div>
          <hr />

          <div class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :columns="columns"
              :rows="rows"
              class="agGrid"
            />
          </div>
        </div>
      </div>
    </div>

    <NoteDialog v-model="dialogNoteVisible">
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>- Tên sự kiện: Hiển thị tên sự kiện</li>
            <li>
              - Thời gian sự kiện: hiển thị thời gian diễn ra sự kiện dưới dạng
              Từ ngày - Đến ngày: Format: DDMMYYYY- DDMMYYYY
            </li>
            <li>
              - Tổng chi phí: Các chi phí chuẩn bị sự kiện, Giảm giá, Quảng cáo
            </li>
            <li>
              - Người phụ trách: hiển thị tên người phụ trách quảng cáo trên nền
              tảng trong thời gian tìm kiếm
            </li>
            <li>
              - Doanh thu phòng: Hiển thị doanh thu phòng trong khoảng thời gian
              diễn ra sự kiện
            </li>
            <li>
              - Dịch vụ khác: Hiển thị doanh thu Dịch vụ đặc biệt, dịch vụ buồng
              phòng
            </li>
            <li>
              - Doanh thu sự kiện: Các doanh thu đến từ dự kiện,..... => được
              nhập tay
            </li>
            <li>
              - Tổng doanh thu: Hiển thị tổng doanh thu của sự kiện = Doanh thu
              phòng + Dịch vụ khách + Doanh thu sự kiện
            </li>
            <li>- Người thao tác: Hiển thị người nhập dữ liệu lên</li>
          </ul>
        </div>
      </div>
    </NoteDialog>
  </div>
</template>

<script>
import DownloadBtn from '../components/DownloadBtn.vue'
import NoteDialog from '../components/NoteDialog.vue'

export default {
  components: { DownloadBtn, NoteDialog },
  data() {
    return {
      // date
      date: {
        start: null,
        end: null
      },

      // grid
      columns: [
        { headerName: 'Tên sự kiện', field: '' },
        { headerName: 'Thời gian sự kiện', field: '' },
        { headerName: 'Tổng chi phí', field: '' },
        { headerName: 'Doanh thu phòng', field: '' },
        { headerName: 'Dịch vụ khác', field: '' },
        { headerName: 'Doanh thu sự kiện', field: '' },
        { headerName: 'Tổng doanh thu', field: '' },
        { headerName: 'Người thao tác', field: '' }
      ],
      rows: [],

      // dialog
      dialogNoteVisible: false
    }
  },
  methods: {
    onSearch() {},
    onResetSearch() {}
  }
}
</script>
